<template>
  <div id="commentManagement">
    <filter-frame
      ref="filter"
      :save-filter="true"
      :filter-form="depositFilter"
      @search="search"
      @clear="clearSearch()"
    />
    <el-table
      class="newslist"
      :data="ListData"
      empty-text="目前無任何留言"
    >
      <el-table-column
        type="index"
        width="50"
      />
      <el-table-column
        prop="Community"
        label="社區"
        width="200"
      />
      <el-table-column
        prop="TabletNote"
        label="戶別"
        width="200"
      />
      <el-table-column
        prop="Content"
        label="留言"
      >
        <template slot-scope="scope">
          <span class="comment-content">{{ scope.row.Content }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Time"
        label="時間"
        width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.Time.split(':')[0].replace(/\//g, '-') }}:{{ scope.row.Time.split(':')[1] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="隱藏此則留言"
        width="110"
        align="center"
      >
        <template slot-scope="scope">
          <span
            class="hideBtn"
            @click="switchHideComment(scope)"
          >
            <i
              :class="scope.row.Status ? 'icon-eye-closed' : 'icon-eye-opened'"
              aria-hidden="true"
            />
          </span>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'

import filterFrame from '@/components/FilterFrame'
export default {
  components: {
    'filter-frame': filterFrame,
    TableLoading
  },
  data () {
    return {
      filter: {
        title: '',
        tabletId: '',
        start: '',
        due: ''
      },
      scrollEnd: false,
      loading: false,
      offset: 0,
      maxCount: 10,
      depositFilter: [
        {
          label: '留言內容',
          name: 'title',
          type: 'input',
          rule: [{ min: 0, max: 100, message: '公告標題限定100字元', trigger: 'blur' }]
        },
        {
          label: '戶別',
          name: 'household',
          type: 'house',
          options: [],
          value: ''
        },
        {
          label: '留言日期',
          name: 'messageDate',
          type: 'date'
        }
      ],
      ListData: []
    }
  },
  mounted () {
    if (!sessionStorage.getItem('filterData')) {
      this.getList()
    }
    window.addEventListener('scroll', this.autoShow, true)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    // 查詢尋
    search (such_val) {
      console.log(such_val)
      this.filter = {
        title: such_val.title ? such_val.title : '',
        tabletId: such_val.household ? such_val.household.TabletId : '',
        start: such_val.messageDate ? such_val.messageDate[0] : '',
        due: such_val.messageDate ? such_val.messageDate[1] : ''
      }
      this.ListData = []
      this.offset = 0
      this.scrollEnd = false
      window.scrollTo(0, 0)
      this.getList()
    },
    // 清除條件
    clearSearch () {
      this.filter = {
        title: '',
        type: '',
        status: '',
        start: '',
        due: ''
      }
      this.ListData = []
      this.offset = 0
      this.scrollEnd = false
      window.scrollTo(0, 0)
      this.getList()
      // localStorage.removeItem('filterData')
    },

    // 取得留言列表
    getList () {
      this.loading = true
      const params = {
        'Batch.Offset': this.offset,
        'Batch.MaxCount': this.maxCount,
        VotingId: this.$route.params.id,
        Keyword: this.filter.title,
        TabletId: this.filter.tabletId,
        StartTime: this.filter.start,
        EndTime: this.filter.due
      }
      apiVote.Vote.GetCommentList(params).then(res => {
        console.log(res)
        this.ListData = this.ListData.concat(res.data.Data)
        if (this.ListData.length > 10) {
          window.scrollTo(0, ScrollHeight - 900)
        }
        if (res.data.Data.length < 10) {
          this.scrollEnd = true
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    switchHideComment (scope) {
      if (scope.row.Status) {
        this.$confirm('確定要對app隱藏此則留言嗎？', '', {
          confirmButtonText: '確認',
          confirmButtonClass: 'el-button--success',
          cancelButtonText: '取消',
          closeOnClickModal: false
        }).then(action => {
          apiVote.Vote.PatchCommentHidden({
            votingId: this.$route.params.id,
            CommentId: scope.row.Id,
            Hide: true
          }).then(res => {
            this.ListData[scope.$index].Status = 0
          }).catch(err => {
            console.log(err)
          })
        }).catch(() => {
        })
      } else {
        apiVote.Vote.PatchCommentHidden({
          votingId: this.$route.params.id,
          CommentId: scope.row.Id,
          Hide: false
        }).then(res => {
          this.ListData[scope.$index].Status = 1
        }).catch(err => {
          console.log(err)
        })
      }
    },

    // 下拉到底自動載入
    autoShow () {
      // 視窗滾動條高度
      const ScrollTop = document.documentElement.scrollTop
      // console.log(`視窗滾動條高度:${ScrollTop}`)
      // 視窗可視範圍高度
      const ClientHeight = document.documentElement.clientHeight
      // console.log(`視窗可視範圍高度:${ClientHeight}`)
      // 內容實際高度
      const ScrollHeight = document.documentElement.scrollHeight
      // console.log(`內容實際高度:${ScrollHeight}`)

      // console.log(ScrollTop+ClientHeight +" : "+ ScrollHeight)
      // console.log(`${ScrollTop+ClientHeight}:${ScrollHeight}`)
      // eslint-disable-next-line eqeqeq
      if ((ScrollTop + ClientHeight >= ScrollHeight - 20) && !this.loading && this.$router.currentRoute.name == 'commentManagement') {
        if (!this.scrollEnd) {
          this.offset += 10
          this.getList()
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#commentManagement
  text-align: center
  padding: 50px 0 10px
  height: 100%
  .newslist
    font-size: 15px
    .cell
      +NewsStatusTag
    .comment-content
      word-break: break-word
    .hideBtn
      &:hover
        cursor: pointer
        opacity: 0.7
      .icon-eye-opened
        color: #d3d3d3
    ::v-deep .el-table
      +basicTable

.el-input__inner
  font-size: 15px !important
</style>
